module.exports = __webpack_public_path__ + "img/picture_kmskcspvip01@2x.3b31ba89.png";